(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    document.querySelectorAll('[data-pgift]').forEach(function (g) {
      var bottle = g.querySelector('[data-gift-bottle]'), flav = g.querySelector('[data-gift-flavour]');
      var msg = g.querySelector('[data-gift-msg]'), sub = g.querySelector('[data-gift-sub]');
      var input = g.querySelector('[data-gift-input]'), inputSub = g.querySelector('[data-gift-input-sub]');
      var left = g.querySelector('[data-gift-left]'), leftSub = g.querySelector('[data-gift-left-sub]');
      var idInput = g.querySelector('[data-gift-id]'), priceEl = g.querySelector('[data-gift-price]'), addBtn = g.querySelector('[data-gift-add]');
      var dataEl = g.querySelector('[data-gift-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var sampleMsg = msg ? msg.textContent : '', sampleSub = sub ? sub.textContent : '';
      function paint() {
        var f = g.querySelector('input[name="gift_flavour"]:checked');
        if (f) { bottle.style.background = f.getAttribute('data-colour'); flav.textContent = f.value; }
        if (input) { msg.textContent = input.value || sampleMsg; left.textContent = input.maxLength - input.value.length; }
        if (inputSub) { sub.textContent = inputSub.value || sampleSub; leftSub.textContent = inputSub.maxLength - inputSub.value.length; }
        var fv = f ? f.value : null;
        g.querySelectorAll('input[name="gift_size"]').forEach(function (r) {
          var v = variants.find(function (x) { return x.f === fv && x.s === r.value; });
          r.disabled = !v;
          var hint = g.querySelector('[data-size-hint="' + r.value + '"]');
          if (hint) hint.textContent = v ? (v.available ? v.price : 'Sold out') : 'Not available';
        });
        var s = g.querySelector('input[name="gift_size"]:checked');
        if (!s || s.disabled) {
          var firstOk = g.querySelector('input[name="gift_size"]:not(:disabled)');
          if (firstOk) { firstOk.checked = true; s = firstOk; }
        }
        var sv = s ? s.value : null;
        var v = variants.find(function (x) { return x.f === fv && (sv === null || x.s === sv); });
        if (v && idInput) {
          idInput.value = v.id; priceEl.textContent = v.price;
          if (addBtn) addBtn.disabled = !v.available;
        } else if (addBtn) { addBtn.disabled = true; }
      }
      g.addEventListener('input', paint); g.addEventListener('change', paint); paint();
    });
  });
})();
